/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_1Inputs */



/**
* | output |
* | --- |
* | "One user license" |
*
* @param {Signup_Feature_Starter_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_1 = /** @type {((inputs?: Signup_Feature_Starter_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "de") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "it") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "ru") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "es") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "ja") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "hi") return /** @type {LocalizedString} */ ("One user license")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("One user license")
	return /** @type {LocalizedString} */ ("One user license")
});